/**
 * module component to check for expired, expiring-soon, and pending
 * agenda items. 
 * 
 * Broke it out into it's own component because it was taking a long time to render 
 * on the main agenda page 
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';


class AgendaStatusAlerts extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(contentModuleActions.fetchListIfNeeded('agenda-status', 'expired'));
    dispatch(contentModuleActions.fetchListIfNeeded('agenda-status', 'expiring-soon'));
    dispatch(contentModuleActions.fetchListIfNeeded('agenda-status', 'pending-attestation'));
  }

  render(){
    const { contentModuleStore } = this.props;

    const expiredList = contentModuleStore.lists['agenda-status'] ? contentModuleStore.lists['agenda-status']['expired'] : {};
    const expiredItems = contentModuleStore.util.getList('agenda-status', 'expired');

    const expiringSoonList = contentModuleStore.lists['agenda-status'] ? contentModuleStore.lists['agenda-status']['expiring-soon'] : {};
    const expiringSoonItems = contentModuleStore.util.getList('agenda-status', 'expiring-soon');

    const pendingList = contentModuleStore.lists['agenda-status'] ? contentModuleStore.lists['agenda-status']['pending-attestation'] : {};
    const pendingItems = contentModuleStore.util.getList('agenda-status', 'pending-attestation');

    const statusesEmpty = (
      !expiredItems
      || !expiringSoonItems
      || !pendingItems
    )

    const statusesFetching = (
      !expiredList 
      || expiredList.isFetching 
      || !expiringSoonList
      || expiringSoonList.isFetching
      || !pendingList 
      || pendingList.isFetching 
    )

    const attentionCerts = !statusesEmpty && expiredItems.concat(pendingItems, expiringSoonItems); 

    // remove any duplicate cert objects in this array.
    const filteredCerts = !statusesEmpty && attentionCerts && attentionCerts.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t._id === value._id 
      ))
    );
    
    return(
      <div >
        { statusesEmpty ?
          null 
          :
          <div style={{opacity: statusesFetching ? 0.5 : 1 }}>
            {filteredCerts.length > 0 ? 
            <div className="-badge">
              {filteredCerts.length}
            </div>
            : null
            }
          </div>
        }
      </div>
    )
  }
}


AgendaStatusAlerts.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    contentModuleStore: store.contentModule 
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AgendaStatusAlerts)
);



// WEBPACK FOOTER //
// modules/agenda/components/AgendaStatusAlerts.js.jsx